module.exports = __webpack_public_path__ + "static/media/data.656ee3e5.svg";